import { connect } from 'react-redux';

import * as Actions from 'app/developer-v3/Actions';
import * as CliApp from 'app/entities/CliApp';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import MaybeRedirectOnMount from 'app/common/components/MaybeRedirectOnMount';
import hocify from 'app/common/components/hocify';
import {
  currentAppEntity,
  currentAppVersion,
} from 'app/developer-v3/selectors';
import { getAppVersionUrl } from 'app/developer-v3/utils';
import { selectAppId } from 'app/developer-v3/store/selectors';

import DashboardPage from './DashboardPage';

const mapStateToProps = state => {
  const appId = selectAppId(state);
  const appEntity = currentAppEntity(state);
  const appName = CliApp.selectors.title(appEntity);
  const appVersion = currentAppVersion(state);
  const serviceId = CliApp.selectors.serviceId(appEntity);
  const slug = CliApp.selectors.slug(appEntity);

  return {
    appId,
    appName,
    appVersion,
    isBeta: CliApp.selectors.isBeta(appEntity),
    isLoading: CliApp.selectors.isLoadImpending(state),
    isPublic: CliApp.selectors.isPublic(appEntity),
    isPublished: CliApp.selectors.isPublished(appEntity),
    status: CliApp.selectors.status(appEntity),
    redirectUrl: getAppVersionUrl(appId, appVersion),
    serviceId,
    slug,
    shouldRedirect:
      CliApp.selectors.isPrivate(appEntity) ||
      (CliApp.selectors.isPublished(appEntity) && !serviceId),
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  async onLoad() {
    const { id } = props.params;
    dispatch(Actions.loadAppAndVersion(id));
  },
});

const Container = connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(MaybeRedirectOnMount)(hocify(LoadingBlockOrComponent)(DashboardPage)));

export default Container;
